<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'site.roomsCommercial' | translate }}
  </div>
  @for(area of areasS(); track area.guid) {
    <ion-item lines="none"
      button="true"
      (click)="onItem(area)">
      {{ area.name }}
      @if (area.users?.length > 0) {
        (
        @for (user of area.users; track $index) {
          {{ user.company }}
        }
        )
      }
    </ion-item>
  }
  @if (empty()) {
    <app-no-results></app-no-results>
  }
</app-main-dialog>